import { ITelemetryLogger } from '@cian/telemetry/shared';

export enum ETelemetryEvents {
  ChatFileDownloadSuccess = 'chats.chat-file-download.success',
  ChatFileDownloadFail = 'chats.chat-file-download.fail',
  ChatWsMessageSendInit = 'chats.chat-ws-message-send.init',
  ChatWsMessageSendSuccess = 'chats.chat-ws-message-send.success',
  ChatWsMessageSendTime = 'chats.chat-ws-message-send.time',
  ChatWsMessageSendFail = 'chats.chat-ws-message-send.fail',
  ChatWsMessageGetModalWarning = 'chats.chat-ws-message-get-modal-warning',
  ChatWsSocketError = 'chats.chat-ws-socket.error',
  ChatWsSocketClose = 'chats.chat-ws-socket.close',
  ChatWsUserStatusSuccess = 'chats.chat-ws-user-status.success',
  ChatWsUserStatusFail = 'chats.chat-ws-user-status.fail',
  ChatPageCrashFail = 'chats.chat-page-crash.fail',
  ChatPageShowErrorPage = 'chats.chat-page-show-error-page',
  ChatPageShow404ErrorPage = 'chats.chat-page-show-not-found-error-page',
  FeedbackChatbotModalShow = 'chats.chat-bot.feedback-show',
  FeedbackChatbotModalShowButton = 'chats.chat-bot.feedback-show.button',
  FeedbackChatbotModalHide = 'chats.chat-bot.feedback-hide',
  FeedbackChatbotModalRating = 'chats.chat-bot.feedback-rating',
  ChatWsConnectionTime = 'chats.chat-ws-connection.time',
  ChatWsFirstMessageGetSuccess = 'chats.chat-ws-first-message-get.success',
  ChatFirstMessageSendInit = 'chats.first-message-send.init',
  ChatFirstMessageSendSuccess = 'chats.first-message-send.success',
  ChatFirstMessageSendTime = 'chats.first-message-send.time',
  ChatFirstMessageSendGetCaptcha = 'chats.first-message-send.warning.get-captcha',
  ChatFirstMessageSendNeedConfirmPhone = 'chats.first-message-send.warning.need-confirm-phone',
  ChatFirstMessageSendChatsDisabled = 'chats.first-message-send.error.chats-disabled',
  ChatFirstMessageSendChatsBlocked = 'chats.first-message-send.error.chats-blocked',
  ChatFirstMessageSendContainsForbiddenText = 'chats.first-message-send.error.contains-forbidden-text',
  ChatFirstMessageSendHasExternalLink = 'chats.first-message-send.error.has-external-link',
  ChatFirstMessageSendValidationError = 'chats.first-message-send.error.validation-error',
  ChatFirstMessageSendUserSendingDisabled = 'chats.first-message-send.error.user-sending-disabled',
  ChatFirstMessageSendOfferNotFound = 'chats.first-message-send.error.offer-not-found',
  ChatFirstMessageSendUserNotFound = 'chats.first-message-send.error.user-not-found',
  ChatFirstMessageSendUserCanNotChatWithHimself = 'chats.first-message-send.error.user-can-not-chat-with-himself',
  ChatFirstMessageSendUserCanNotChatWithHisColleagues = 'chats.first-message-send.error.user-can-not-chat-with-his-colleagues',
  ChatFirstMessageSendWrongCaptchaToken = 'chats.first-message-send.error.wrong-captcha-token',
  ChatFirstMessageSendChatNotFound = 'chats.first-message-send.error.chat-not-found',
  ChatFirstMessageSendUnknownError = 'chats.first-message-send.error.unknown-error',
  ChatWsAnswerSendSuccess = 'chats.chat-ws-answer-send.success',
  ChatWsAnswerSendFail = 'chats.chat-ws-answer-send.fail',
  ChatNotificationShow = 'chats.chat-notification-show',
  ClientInfoBubbleShowSuccess = 'chats.client-info-bubble-show.success',
  ClientInfoTabShowSuccess = 'chats.client-info-tab-show.success',
  MarkMessagesAsReadSuccess = 'chats.chat-messages-read.success',
  MarkMessagesAsReadFail = 'chats.chat-messages-read.fail',
  MarkMessagesAsStarredSuccess = 'chats.chat-messages-mark-starred.success',
  MarkMessagesAsStarredFail = 'chats.chat-messages-mark-starred.fail',
  UnmarkMessagesAsStarredSuccess = 'chats.chat-messages-unmark-starred.success',
  UnmarkMessagesAsStarredFail = 'chats.chat-messages-unmark-starred.fail',
  ChatWsMessageGet = 'chats.chat-ws-message-get',
  ChatsSynchronizeInit = 'chats.chats-synchronize.init',
  ChatsSynchronizeSuccess = 'chats.chats-synchronize.success',
  ChatsSynchronizeTime = 'chats.chats-synchronize.time',
  ChatsSynchronizeFail = 'chats.chats-synchronize.fail',
  ChatsGetInit = 'chats.chats-get.init',
  ChatsGetSuccess = 'chats.chats-get.success',
  ChatsGetTime = 'chats.chats-get.time',
  ChatsGetFail = 'chats.chats-get.fail',
  ChatbotReadMessagesFail = 'chatbot.read-messages.fail',
  ChatbotMessagesFail = 'chatbot.messages.fail',
  ChatbotGetFiltersMicrofrontendFail = 'chatbot.get-filters-microfrontend.fail',
  ExperimentsFetchFail = 'experiments.fetch.fail',
  ChatbotActionButtonsFail = 'chatbot.action-buttons.fail',
  ChatbotSetRatingFail = 'chatbot.set-rating.fail',
  ChatbotViewOfferFail = 'chatbot.view-offer.fail',
  ChatbotCloseRatingFail = 'chatbot.close-rating.fail',
}

export type TAppTelemetryLogger = Omit<ITelemetryLogger, 'timer'>;
